module.exports = function() {
    $('.filtertron').filtertron('entries', {
        expander: '#filtertronExpander'
    });
};